import { TradeWay } from 'components/secondaryMarket/shared/SidePanel/TradeWay';
import { Price, StatusBottomBar, StatusContainerWithActionBar } from 'components/secondaryMarket/shared/status';
import { useIntl } from 'react-intl';
import type { SecondaryPriceType } from 'state/secondaryMarket/productSearch';
import type { TradeWay as TradeWayModel } from 'state/secondaryMarket/secondaryMarket.model';

interface TradedStatusProps {
  price: number;
  priceType: SecondaryPriceType;
  priceCurrency: string;
  tradeWay: TradeWayModel;
}

export const TradedStatus = ({ price, priceType, priceCurrency, tradeWay }: TradedStatusProps) => {
  const { formatMessage } = useIntl();

  return (
    <>
      <StatusContainerWithActionBar className="w-100 d-flex flex-column alert alert-discreet-info rounded-top-3">
        <div className="d-flex flex-column">
          <TradeWay tradeWay={tradeWay} />
          {formatMessage({ id: 'secondaryMarket.sidePanel.label.settlementPrice' })}
        </div>
        <div className="px-0 py-2">
          <Price price={price} priceType={priceType} priceCurrency={priceCurrency} />
        </div>
      </StatusContainerWithActionBar>
      <div className="bg-info bg-opacity-05" />
      <StatusBottomBar className="w-100 d-flex mb-0 bg-info rounded-bottom-3">
        <div className="card-body px-3 d-flex align-items-center ">
          <em className="icon icon-sm">check_circle</em>
          <span className="ms-2 flex-grow-1" data-e2e="secondary-side-panel-status">
            {formatMessage({
              id: 'secondaryMarket.sidePanel.label.tradeDone',
            })}
          </span>
        </div>
      </StatusBottomBar>
    </>
  );
};
